// extracted by mini-css-extract-plugin
export default {"container":"startupCount_container__QKhT8","active-container":"startupCount_active-container__JyWsI"};